import {
  CtoManagerPermissions,
  CtoPermissions,
  GroupPermission,
  OthersPermissions,
} from "../../../types/permissionTypes";

export const manageRequestMock: GroupPermission = {
  description: "Manage request",
  name: "Manage request",
  enable: true,
  id: OthersPermissions.MANAGE_REQUEST,
};

export const allPermissionsMock: GroupPermission[] = [
  {
    description: "CTO - Identification",
    name: "CTO - Identification",
    enable: true,
    id: CtoPermissions.IDENTIFICATION,
  },
  {
    description: "CTO Initiation",
    name: "CTO Initiation",
    enable: true,
    id: CtoPermissions.INITIATION,
  },
  {
    description: "CTO Evaluation and Risk Assessment",
    name: "CTO Evaluation and Risk Assessment",
    enable: true,
    id: CtoPermissions.EVALUATION,
  },
  {
    description: "CTO Review",
    name: "CTO Review",
    enable: true,
    id: CtoPermissions.REVIEW,
  },
  {
    description: "CTO Approval",
    name: "CTO Approval",
    enable: true,
    id: CtoPermissions.APPROVAL,
  },
  {
    description: "CTO Mitigation Action Implementation",
    name: "CTO Mitigation Action Implementation",
    enable: true,
    id: CtoPermissions.MITIGATION,
  },
  {
    description: "CTO Re-assessment for Closure",
    name: "CTO Re-assessment for Closure",
    enable: true,
    id: CtoPermissions.REASSESSMENT,
  },
  {
    description: "CTO Closure Verification",
    name: "CTO Closure Verification",
    enable: true,
    id: CtoPermissions.VERIFICATION,
  },
  {
    description: "CTO Closure Approval",
    name: "CTO Closure Approval",
    enable: true,
    id: CtoPermissions.CLOSURE,
  },
  {
    description: "Extend CTO Period",
    name: "Extend CTO Period",
    enable: true,
    id: CtoManagerPermissions.EXTEND,
  },
  {
    description: "Close CTO",
    name: "Close CTO",
    enable: true,
    id: CtoManagerPermissions.CLOSE,
  },
  {
    description: "Change WO status",
    name: "Change WO status",
    enable: true,
    id: OthersPermissions.CHANGE_WO,
  },
  manageRequestMock,
  {
    description: "Change other user's permissions",
    name: "Change other user's permissions",
    enable: true,
    id: OthersPermissions.PERMISSIONS,
  },
];
